import { ComponentType } from 'react';
import DataTable, {
  DataTableWrapper,
  useTableQueryParams,
} from 'src/components/DataTable';
import { CellProps, Column, Row } from 'src/components/DataTable/types';
import { SiteDeviceNodesItem, SiteDeviceNodesItemField, SiteClusterProviderType } from '../../types';
import NodeItemStatus from './NodeItemStatus';
import NodesListAction from './NodesListAction';

const getGpuCpuDetailsColConfig = <TRow extends Row = Row>(
  Component: ComponentType<CellProps<any, TRow>>
): Column<TRow> => ({
  id: 'gpuCpuDetails',
  title: 'GPU/CPU Details',
  sortable: false,
  Component,
});

const gpuCpuDetailsColumn = getGpuCpuDetailsColConfig(NodesListAction);

const allColumns = [
  {
    id: SiteDeviceNodesItemField.HostName,
    title: 'Host Name',
  },
  {
    id: SiteDeviceNodesItemField.IpAddress,
    title: 'IP Address',
  },
  {
    id: SiteDeviceNodesItemField.Status,
    title: 'Status',
    Component: NodeItemStatus,
  },
  {
    id: SiteDeviceNodesItemField.InstanceType,
    title: 'Instance Type',
  },
  {
    id: SiteDeviceNodesItemField.Name,
    title: 'Roles',
  },
  {
    id: SiteDeviceNodesItemField.KubernetesVersion,
    title: 'K8s Version',
  },
  {
    id: SiteDeviceNodesItemField.OperatingSystem,
    title: 'OS',
  },
  {
    id: SiteDeviceNodesItemField.Pods,
    title: 'Pods',
  },
  gpuCpuDetailsColumn,
];

const spectroColumns = [
  { id: SiteDeviceNodesItemField.HostName, title: 'Host Name' },
  { id: SiteDeviceNodesItemField.Status, title: 'Status', Component: NodeItemStatus },
  { id: SiteDeviceNodesItemField.Name, title: 'Roles' },
  gpuCpuDetailsColumn,
];

type Props = {
  data?: SiteDeviceNodesItem[];
  providerType?: string;
};

function NodesList({ data = [], providerType }: Props) {
  const { paging: nodePaging, sorting: nodeSorting } = useTableQueryParams();
  const isSpectro = providerType?.toLowerCase() === SiteClusterProviderType.Spectro.toLowerCase();
  const columns = isSpectro ? spectroColumns : allColumns;
  return (
    <DataTableWrapper
      sx={{ marginTop: '1%' }}
      title="Nodes"
      titleStyle={{ fontWeight: '700', fontSize: '16px', fontFamily: 'Roboto' }}
      searchBar={false}
    >
      <DataTable
        columns={columns}
        data={data}
        {...nodePaging}
        {...nodeSorting}
      />
    </DataTableWrapper>
  );
}

export default NodesList;
